/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPPROPOSALSTATUS = {
    ProposalInProgress: '1',
    ProposalComplete: '2',
    ApplicationInProgress: '3',
    ApplicationComplete: '4',
    SigningInProgress: '5',
    SigningComplete: '6'
} as const;
export type IAPPROPOSALSTATUS = typeof IAPPROPOSALSTATUS[keyof typeof IAPPROPOSALSTATUS];


export function IAPPROPOSALSTATUSFromJSON(json: any): IAPPROPOSALSTATUS {
    return IAPPROPOSALSTATUSFromJSONTyped(json, false);
}

export function IAPPROPOSALSTATUSFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPPROPOSALSTATUS {
    return json as IAPPROPOSALSTATUS;
}

export function IAPPROPOSALSTATUSToJSON(value?: IAPPROPOSALSTATUS | null): any {
    return value as any;
}

